import { List } from "../Utils/List";
import { Dictionary } from "../Utils/Dictionary";
import { HashSet } from "../Utils/HashSet";
import { ObjUtils, Iterable, IComparable } from "../Utils/ObjUtils";
import { Device } from "./Device";
import { IpAddress, IpVersion } from "./IpAddress";
import { MacAddress } from "./MacAddress";
import { DeviceSet, SerialNumberInfo, NetBiosNameInfo, SystemNameInfo, HostNameInfo } from "./DeviceSet";
import { DependentDeviceId } from "./DependentDeviceId";
import { SystemInfo } from "../InfoSets/SystemInfo";
import { InfoSet, Age } from "../InfoSets/InfoSet";
import { NetworkDiffSettings } from "./NetworkDiffSettings";

export class SmallSet<T> {
    private _items: List<T>;

    constructor() {
        this._items = new List<T>();
    }

    public Add(value: T): boolean {
        if (this.Contains(value)) {
            return false;
        }
        else {
            this._items.Add(value);
            return true;
        }
    }

    public Contains(value: T): boolean {
        return this._items.Contains(value);
    }

    public ContainsAll(values: Iterable<T>): boolean {
        return !values.Some((value) => {
            return !this.Contains(value);
        }, this);
    }
}

export class MatchingDevice implements IComparable {
	public Device: Device;
	public Score: number;

	constructor(device: Device, score: number) {
		this.Device = device;
		this.Score = score;
	}

    public CompareTo(other: MatchingDevice): number {
            
        // Sort in descending order

		if (this.Score > other.Score)
			return -1;
			
		if (this.Score < other.Score)
			return 1;

		return 0;
	}

	public Equals(obj: any): boolean {

		throw new Error("Unsupported Operation");

		//if (obj == this)
		//	return true;
		//if(obj == null)
		//	return false;

		//if (!(obj instanceof MatchingDevice))
		//	return false;
		//var other = <MatchingDevice>obj;
		//if (this.Score != other.Score)
		//	return false;

		//return ObjUtils.Equals(this, other.Device);
	}

	public GetHashCode(): number {

		throw new Error("Unsupported Operation");

		//var result = 0;

		//if (this.Device)
		//	result ^= this.Device.GetHashCode();

		//result ^= ObjUtils.GetHashCode(this.Score);

		//return result;
	}
}

export class MatchResult {
    public IsMatch: boolean;
    public Score: number;

    constructor(isMatch: boolean, score: number) {
        this.IsMatch = isMatch;
        this.Score = score;
    }
}

export class DeviceIdentityAttrs {
    public MacAddresses: HashSet<MacAddress>;
    public NbName: NetBiosNameInfo
    public SysName: SystemNameInfo
    public IpAddresses: HashSet<IpAddress>;
    public HostName: HostNameInfo;
    public SerialNumbers: HashSet<SerialNumberInfo>;
    public DependentDeviceId: DependentDeviceId;

    public get HasMacAddresses(): boolean {
        return (this.MacAddresses.Count > 0);
    }
    public get HasNbName(): boolean {
        return (this.NbName != null);
    }
    public get HasSysName(): boolean {
        return (this.SysName != null);
    }
    public get HasIpAddresses(): boolean {
        return (this.IpAddresses.Count > 0);
    }
    public get HasHostName(): boolean {
        return (this.HostName != null);
    }
    public get HasSerialNumbers(): boolean {
        return (this.SerialNumbers.Count > 0);
    }
    public get HasDependentDeviceId(): boolean {
        return (this.DependentDeviceId != null);
    }

    constructor(device?: Device) {
        if (device) {
            this.DependentDeviceId = null;
            if (device.HasDependentDeviceId) {
                this.DependentDeviceId = device.DependentDeviceId;
            }

            this.MacAddresses = new HashSet<MacAddress>(device.MacAddresses);

            this.IpAddresses = new HashSet<IpAddress>(device.IpAddresses);

            this.SerialNumbers = new HashSet<SerialNumberInfo>(device.SerialNumbers);

            this.NbName = null;
            this.SysName = null;
            this.HostName = null;
            if (device.HasSystemInfo) {
                var sysInfo: SystemInfo = device.SystemInfo;
                if (sysInfo.HasNetBiosName) {
                    this.NbName = new NetBiosNameInfo(sysInfo.NetBiosName, sysInfo.NetBiosDomain);
                }
                if (sysInfo.HasSystemName) {
                    this.SysName = new SystemNameInfo(sysInfo.SystemName, sysInfo.SystemOID);
                }
                if (sysInfo.HasHostname) {
                    this.HostName = new HostNameInfo(sysInfo.Hostname);
                }
            }
        }
        else {
            this.MacAddresses = new HashSet<MacAddress>();
            this.NbName = null;
            this.SysName = null;
            this.IpAddresses = new HashSet<IpAddress>();
            this.HostName = null;
            this.SerialNumbers = new HashSet<SerialNumberInfo>();
            this.DependentDeviceId = null;
        }
    }

    public RemoveDuplicateAttrs(useDupIdAttrs: boolean, useDupMacs: boolean, devices: DeviceSet): void {
        var list: List<Device> = null;

        if (!useDupMacs) {
            this.MacAddresses.ToList().ForEach((value) => {
                list = devices.FindByMacAddress(value);
                if (list != null && list.Count > 1)
                    this.MacAddresses.Remove(value);
            }, this);
        }

        if (!useDupIdAttrs) {
            this.IpAddresses.ToList().ForEach((value) => {
                list = devices.FindByIpAddress(value);
                if (list != null && list.Count > 1)
                    this.IpAddresses.Remove(value);
            }, this);

            this.SerialNumbers.ToList().ForEach((value) => {
                list = devices.FindBySerialNumber(value);
                if (list != null && list.Count > 1)
                    this.SerialNumbers.Remove(value);
            }, this);

            if (this.HasNbName) {
                list = devices.FindByNetBiosName(this.NbName);
                if (list != null && list.Count > 1)
                    this.NbName = null;
            }
            if (this.HasSysName) {
                list = devices.FindBySystemName(this.SysName);
                if (list != null && list.Count > 1)
                    this.SysName = null;
            }

            if (this.HasHostName) {
                list = devices.FindByHostName(this.HostName);
                if (list != null && list.Count > 1)
                    this.HostName = null;
            }

            if (this.HasDependentDeviceId) {
                list = devices.FindDependentDevicesById(this.DependentDeviceId);
                if (list != null && list.Count > 1)
                    this.DependentDeviceId = null;
            }
        }
    }
}

export class DeviceIdentityAttrMatches {
	public MacMatches: Dictionary<Device, MacAddress[]>;
	public NbNameMatches: HashSet<Device>;
	public SysNameMatches: HashSet<Device>;
	public IpMatches: Dictionary<Device, IpAddress[]>;
	public HostNameMatches: HashSet<Device>;
    public SerialNumberMatches: Dictionary<Device, SerialNumberInfo[]>;
    public DependentDeviceIdMatches: HashSet<Device>;

	constructor() {
		this.MacMatches = new Dictionary<Device, MacAddress[]>();
		this.NbNameMatches = new HashSet<Device>();
		this.SysNameMatches = new HashSet<Device>();
		this.IpMatches = new Dictionary<Device, IpAddress[]>();
		this.HostNameMatches = new HashSet<Device>();
        this.SerialNumberMatches = new Dictionary<Device, SerialNumberInfo[]>();
        this.DependentDeviceIdMatches = new HashSet<Device>();
	}

	public get AllMatches(): HashSet<Device> {
		var allMatches = new HashSet<Device>();

		allMatches.UnionWith(this.MacMatches.Keys());
		allMatches.UnionWith(this.NbNameMatches);
		allMatches.UnionWith(this.SysNameMatches);
		allMatches.UnionWith(this.IpMatches.Keys());
		allMatches.UnionWith(this.HostNameMatches);
        allMatches.UnionWith(this.SerialNumberMatches.Keys());
        allMatches.UnionWith(this.DependentDeviceIdMatches);

		return allMatches;
	}
}

export class DeviceIdAttrCache {
    private attrCache: Dictionary<Device, DeviceIdentityAttrs>;
    private oldDevices: DeviceSet;
    private newDevices: DeviceSet;
    private useDupIdAttrs: boolean;
    private useDupMacs: boolean;

    constructor(oldDevices: DeviceSet, newDevices: DeviceSet, useDupIdAttrs: boolean, useDupMacs: boolean) {
        this.attrCache = new Dictionary<Device, DeviceIdentityAttrs>();
        this.oldDevices = oldDevices;
        this.newDevices = newDevices;
        this.useDupIdAttrs = useDupIdAttrs;
        this.useDupMacs = useDupMacs;
    }

    private GetDevices(age: Age): DeviceSet {
        switch (age) {
            case Age.Old:
                return this.oldDevices;
            case Age.New:
                return this.newDevices;
            default:
                return null;
        }
    }

    public GetDeviceIdAttrs(d: Device, age: Age): DeviceIdentityAttrs {
        var attrs: DeviceIdentityAttrs = null;

        if (this.attrCache.ContainsKey(d)) {
            attrs = this.attrCache.Item(d);
        }
        else {
            attrs = new DeviceIdentityAttrs(d);
            attrs.RemoveDuplicateAttrs(this.useDupIdAttrs, this.useDupMacs, this.GetDevices(age));
            this.attrCache.Add(d, attrs);
        }

        return attrs;
    }
}

export class NetworkDiffer {

    // Used to resolve device keys
    public static GetMatchingDevices(oldDevIdAttrs: DeviceIdentityAttrs,
        newDevices: DeviceSet,
        settings: NetworkDiffSettings): List<MatchingDevice> {

        var oldDevices: DeviceSet = null;

        var devIdAttrMatches: DeviceIdentityAttrMatches =
            this.GetDeviceIdentityAttrMatches(oldDevIdAttrs, oldDevices, newDevices, settings);

        var cache = new DeviceIdAttrCache(oldDevices, newDevices,
            settings.UseDuplicateIdentityAttrs,
            settings.UseDuplicateMacs);

		let ThresholdScore = 1;
        return this._GetMatchingDevices(oldDevIdAttrs, devIdAttrMatches, cache, ThresholdScore);
    }

    private static GetDeviceIdentityAttrMatches(
        oldDevIdAttrs: DeviceIdentityAttrs,
        oldDevices: DeviceSet, newDevices: DeviceSet,
        settings: NetworkDiffSettings): DeviceIdentityAttrMatches {

        var attrMatches = new DeviceIdentityAttrMatches();

        // Find devices that match oldDevice on at least one identifying datum
        this.FindMacMatches(oldDevIdAttrs.MacAddresses, oldDevices, newDevices, settings, attrMatches.MacMatches);

        this.FindNetBiosNameMatches(oldDevIdAttrs.NbName, oldDevices, newDevices, settings, attrMatches.NbNameMatches);

        this.FindSystemNameMatches(oldDevIdAttrs.SysName, oldDevices, newDevices, settings, attrMatches.SysNameMatches);

        if (settings.UseIpAddrsForIdentity) {
            this.FindIpAddressMatches(oldDevIdAttrs.IpAddresses, oldDevices, newDevices, settings, attrMatches.IpMatches);
        }

        if (settings.UseHostNamesForIdentity) {
            this.FindHostNameMatches(oldDevIdAttrs.HostName, oldDevices, newDevices, settings, attrMatches.HostNameMatches);
        }

        this.FindSerialNumberMatches(oldDevIdAttrs.SerialNumbers, oldDevices, newDevices, settings, attrMatches.SerialNumberMatches);

        this.FindDependentDeviceIdMatches(oldDevIdAttrs.DependentDeviceId, oldDevices, newDevices, settings, attrMatches.DependentDeviceIdMatches);

        return attrMatches;
    }

    private static _GetMatchingDevices(oldDevIdAttrs: DeviceIdentityAttrs,
        devIdAttrMatches: DeviceIdentityAttrMatches,
        cache: DeviceIdAttrCache, thresholdScore: number): List<MatchingDevice> {

        var result = new List<MatchingDevice>();

        var allMatches: HashSet<Device> = devIdAttrMatches.AllMatches;

        allMatches.ForEach((match) => {
            var newDevIdAttrs: DeviceIdentityAttrs = cache.GetDeviceIdAttrs(match, Age.New);

            var matchResult: MatchResult = NetworkDiffer.IsMatch(oldDevIdAttrs, newDevIdAttrs, thresholdScore);
            if (matchResult.IsMatch) {
                result.Add(new MatchingDevice(match, matchResult.Score));
            }

        }, this);

        result.Sort((a, b) => { return a.CompareTo(b); });

        return result;
    }

	public static IsMatch(oldDevIdAttrs: DeviceIdentityAttrs, newDevIdAttrs: DeviceIdentityAttrs,
							thresholdScore: number): MatchResult {

        var MacMatchPoints = 3;
        var MacMismatchPoints = -2;
        var DepDevIdMatchPoints = 3;
        var DepDevIdMismatchPoints = -2;
        var SerialNumberMatchPoints = 2;
        var SerialNumberMismatchPoints = -1;
        var NbNameMatchPoints = 2;
        var NbNameMismatchPoints = -1;
        var SysNameMatchPoints = 1;
        var SysNameMismatchPoints = -1;
        var IpMatchPoints = 1;
        var IpMismatchPoints = -1;
        var HostNameMatchPoints = 1;
        var HostNameMismatchPoints = -1;

        var score = 0;

        switch (this.AreMacAddressesCompatible(oldDevIdAttrs.MacAddresses, newDevIdAttrs.MacAddresses)) {
            case true:
                score += MacMatchPoints;
                break;
            case false:
                score += MacMismatchPoints;
                break;
            default:
                break;
        }
        switch (this.AreNetBiosNamesCompatible(oldDevIdAttrs.NbName, newDevIdAttrs.NbName)) {
            case true:
                score += NbNameMatchPoints;
                break;
            case false:
                score += NbNameMismatchPoints;
                break;
            default:
                break;
        }
        switch (this.AreSystemNamesCompatible(oldDevIdAttrs.SysName, newDevIdAttrs.SysName)) {
            case true:
                score += SysNameMatchPoints;
                break;
            case false:
                score += SysNameMismatchPoints;
                break;
            default:
                break;
        }
        switch (this.AreIpAddressesCompatible(oldDevIdAttrs.IpAddresses, newDevIdAttrs.IpAddresses)) {
            case true:
                score += IpMatchPoints;
                break;
            case false:
                score += IpMismatchPoints;
                break;
            default:
                break;
        }
        switch (this.AreHostNamesCompatible(oldDevIdAttrs.HostName, newDevIdAttrs.HostName)) {
            case true:
                score += HostNameMatchPoints;
                break;
            case false:
                score += HostNameMismatchPoints;
                break;
            default:
                break;
        }
        switch (this.AreSerialNumbersCompatible(oldDevIdAttrs.SerialNumbers, newDevIdAttrs.SerialNumbers)) {
            case true:
                score += SerialNumberMatchPoints;
                break;
            case false:
                score += SerialNumberMismatchPoints;
                break;
            default:
                break;
        }
        switch (this.AreDependentDeviceIdsCompatible(oldDevIdAttrs.DependentDeviceId, newDevIdAttrs.DependentDeviceId)) {
            case true:
                score += DepDevIdMatchPoints;
                break;
            case false:
                score += DepDevIdMismatchPoints;
                break;
            default:
                break;
        }

        return new MatchResult(score >= thresholdScore, score);
    }

    private static AreMacAddressesCompatible(oldDevMacs: HashSet<MacAddress>,
        newDevMacs: HashSet<MacAddress>): boolean {

		if (oldDevMacs.Count == 0 || newDevMacs.Count == 0)
			return null;

		var allMacs = new HashSet<MacAddress>(oldDevMacs);
		allMacs.UnionWith(newDevMacs);

		var overlappedMacs = 0;
		allMacs.ForEach((mac) => {
			if (oldDevMacs.Contains(mac) && newDevMacs.Contains(mac)) {
				++overlappedMacs;
			}
		});

		if (overlappedMacs == oldDevMacs.Count) {
			// The old device MACs are a subset of the new device MACs
			return true;
		}
		else if (overlappedMacs == newDevMacs.Count) {
			// The new device MACs are a subset of the old device MACs
			return true;
		}
		else {
			// Compute the percentage of MAC overlap between the two devices.
			// If the percentage is high enough, the devices are compatible.
			// (Virtual MACs sometimes change over time on the same device,
			// so a device's MACs are not constant.  Therefore, we do not
			// require all MACs to match perfectly in order to consider the
			// devices MAC-compatible.)

			var percentage = overlappedMacs / allMacs.Count;

			var Threshold = 0.5;
			if (percentage > Threshold) {
				return true;
			}
			else {
				return false;
			}
		}
	}

    private static AreNetBiosNamesCompatible(oldDevNbName: NetBiosNameInfo,
        newDevNbName: NetBiosNameInfo): boolean {

		if (oldDevNbName == null || newDevNbName == null)
			return null;

		if (oldDevNbName.Equals(newDevNbName))
			return true;
		else
			return false;
	}

    private static AreSystemNamesCompatible(oldDevSysName: SystemNameInfo,
        newDevSysName: SystemNameInfo): boolean {

		if (oldDevSysName == null || newDevSysName == null)
			return null;

		if (!oldDevSysName.HasSystemOID || !newDevSysName.HasSystemOID)
			return null;

		if (oldDevSysName.Equals(newDevSysName))
			return true;
		else
			return false;
	}

    private static AreIpAddressesCompatible(oldDevIps: HashSet<IpAddress>,
        newDevIps: HashSet<IpAddress>): boolean {

        if (oldDevIps.Count == 0 || newDevIps.Count == 0)
			return null;

		var allIps = new HashSet<IpAddress>(oldDevIps);
		allIps.UnionWith(newDevIps);

		var overlappedIps = 0;
		allIps.ForEach((ip) => {
			if (oldDevIps.Contains(ip) && newDevIps.Contains(ip)) {
				++overlappedIps;
			}
		});

		if (overlappedIps == oldDevIps.Count) {
			// The old device IPs are a subset of the new device IPs
			return true;
		}
		else if (overlappedIps == newDevIps.Count) {
			// The new device IPs are a subset of the old device IPs
			return true;
		}
		else {
			// Compute the percentage of IP overlap between the two devices.
			// If the percentage is high enough, the devices are compatible.
			// (IPs sometimes change over time on the same device,
			// so a device's IPs are not constant.  Therefore, we do not
			// require all IPs to match perfectly in order to consider the
			// devices IP-compatible.)

			var percentage = overlappedIps / allIps.Count;

			var Threshold = 0.5;
			if (percentage > Threshold) {
				return true;
			}
			else {
				return false;
			}
		}
	}

    private static AreHostNamesCompatible(oldDevHostName: HostNameInfo,
        newDevHostName: HostNameInfo): boolean {

		if (oldDevHostName == null || newDevHostName == null)
			return null;

        if (oldDevHostName.HostName != newDevHostName.HostName)
			return false;

		return true;
	}

    private static AreSerialNumbersCompatible(oldDevSerNums: HashSet<SerialNumberInfo>,
        newDevSerNums: HashSet<SerialNumberInfo>): boolean {

		if (oldDevSerNums.Count == 0 || newDevSerNums.Count == 0)
			return null;

		var allSerNums = new HashSet<SerialNumberInfo>(oldDevSerNums);
		allSerNums.UnionWith(newDevSerNums);

		var overlappedSerNums = 0;
		allSerNums.ForEach((serNum) => {
			if (oldDevSerNums.Contains(serNum) && newDevSerNums.Contains(serNum)) {
				++overlappedSerNums;
			}
		});

		if (overlappedSerNums == oldDevSerNums.Count) {
			// The old device serial numbers are a subset of the new device serial numbers
			return true;
		}
		else if (overlappedSerNums == newDevSerNums.Count) {
			// The new device serial numbers are a subset of the old device serial numbers
			return true;
		}
		else {
			// Compute the percentage of serial number overlap between the two devices.
			// If the percentage is high enough, the devices are compatible.

			var percentage = overlappedSerNums / allSerNums.Count;

			var Threshold = 0.5;
			if (percentage > Threshold) {
				return true;
			}
			else {
				return false;
			}
		}
    }

    private static AreDependentDeviceIdsCompatible(oldDepDevId: DependentDeviceId,
        newDepDevId: DependentDeviceId): boolean {

        if (oldDepDevId == null || newDepDevId == null)
            return null;

        if (oldDepDevId.Equals(newDepDevId))
            return true;
        else
            return false;
    }


	private static FindMacMatches(oldDevMacs: HashSet<MacAddress>,
		oldDevices: DeviceSet, newDevices: DeviceSet,
        settings: NetworkDiffSettings,
        macMatches: Dictionary<Device, Array<MacAddress>>) {

		oldDevMacs.ForEach((mac) => {
			if (oldDevices != null) {
				var oldDevicesWithMac: List<Device> = oldDevices.FindByMacAddress(mac);
				if ((oldDevicesWithMac == null) ||
                    (!settings.UseDuplicateMacs/*UseDuplicateIdentityAttrs*/ && oldDevicesWithMac.Count != 1)) {
					// The MAC address is not unique in the old network
					return;
				}
			}

			var newDevicesWithMac: List<Device> = newDevices.FindByMacAddress(mac);
			if ((newDevicesWithMac == null) ||
                (!settings.UseDuplicateMacs/*UseDuplicateIdentityAttrs*/ && newDevicesWithMac.Count != 1)) {
				// The MAC address is not unique in the new network
				return;
			}

			newDevicesWithMac.ForEach((newDevice) => {
				if (!macMatches.ContainsKey(newDevice)) {
					macMatches.Add(newDevice, new Array<MacAddress>());
				}
				macMatches.Item(newDevice).push(mac);
			}, this);
		}, this);	
	}

	private static FindNetBiosNameMatches(oldDevNbName: NetBiosNameInfo,
		oldDevices: DeviceSet, newDevices: DeviceSet,
		settings: NetworkDiffSettings,
		nbNameMatches: HashSet<Device>) {

		if (oldDevNbName != null) {
			if (oldDevices != null) {
				var oldDevicesWithNbName: List<Device> = oldDevices.FindByNetBiosName(oldDevNbName);
				if ((oldDevicesWithNbName == null) ||
					(!settings.UseDuplicateIdentityAttrs && oldDevicesWithNbName.Count != 1)) {
					// The NetBIOS info is not unique in the old network
					return;
				}
			}

			var newDevicesWithNbName: List<Device>  = newDevices.FindByNetBiosName(oldDevNbName);
			if ((newDevicesWithNbName == null) ||
				(!settings.UseDuplicateIdentityAttrs && newDevicesWithNbName.Count != 1)) {
				// The NetBIOS info is not unique in the new network
				return;
			}

			// We found matches on NetBIOS info
            newDevicesWithNbName.ForEach((newDevice, index, array) => {
                nbNameMatches.Add(newDevice);
            }, this);
		}
	}

	private static FindSystemNameMatches(oldDevSysName: SystemNameInfo,
		oldDevices: DeviceSet, newDevices: DeviceSet,
        settings: NetworkDiffSettings, sysNameMatches: HashSet<Device>) {

		if (oldDevSysName != null) {
			if (oldDevices != null) {
				var oldDevicesWithSysName: List<Device> = oldDevices.FindBySystemName(oldDevSysName);
				if ((oldDevicesWithSysName == null) ||
					(!settings.UseDuplicateIdentityAttrs && oldDevicesWithSysName.Count != 1)) {
					// The system name is not unique in the old network
					return;
				}
			}

			var newDevicesWithSysName: List<Device> = newDevices.FindBySystemName(oldDevSysName);
			if ((newDevicesWithSysName == null) ||
				(!settings.UseDuplicateIdentityAttrs && newDevicesWithSysName.Count != 1)) {
				// The system name is not unique in the new network
				return;
			}

			// We found matches on system name
            newDevicesWithSysName.ForEach((newDevice, index, array) => {
                sysNameMatches.Add(newDevice);
            }, this);
		}
	}

	private static FindIpAddressMatches(oldDevIps: HashSet<IpAddress>,
		oldDevices: DeviceSet, newDevices: DeviceSet,
        settings: NetworkDiffSettings,
        ipMatches: Dictionary<Device, Array<IpAddress>>) {

		oldDevIps.ForEach((ip) => {
			if (settings.UseIpAddrForIdentity(ip)) {
				if (oldDevices != null) {
					var oldDevicesWithIp: List<Device> = oldDevices.FindByIpAddress(ip);
					if ((oldDevicesWithIp == null) ||
						(!settings.UseDuplicateIdentityAttrs && oldDevicesWithIp.Count != 1)) {
						// The IP address is not unique in the old network
						return;
					}
				}

				var newDevicesWithIp: List<Device> = newDevices.FindByIpAddress(ip);
				if ((newDevicesWithIp == null) ||
					(!settings.UseDuplicateIdentityAttrs && newDevicesWithIp.Count != 1)) {
					// The IP address is not unique in the new network
					return;
				}

				//// We found a match on IP address
				//Device newDevice = newDevicesWithIp[0];
				//if (!ipMatches.ContainsKey(newDevice))
				//{
				//    ipMatches[newDevice] = new List<IpAddress>();
				//}
				//ipMatches[newDevice].Add(ip);

				// We found matches on IP address
                newDevicesWithIp.ForEach((newDevice, index, array) => {
                    if (!ipMatches.ContainsKey(newDevice)) {
                        ipMatches.Add(newDevice, new Array<IpAddress>());
                    }
                    ipMatches.Item(newDevice).push(ip);
                }, this);
			}
		}, this);
	}

	private static FindHostNameMatches(oldDevHostName: HostNameInfo,
		oldDevices: DeviceSet, newDevices: DeviceSet,
		settings: NetworkDiffSettings,
        hostNameMatches: HashSet<Device>) {

		if (oldDevHostName != null) {
			if (settings.UseHostNameForIdentity(oldDevHostName.HostName)) {
				if (oldDevices != null) {
					var oldDevicesWithHostName: List<Device> = oldDevices.FindByHostName(oldDevHostName);
					if ((oldDevicesWithHostName == null) ||
						(!settings.UseDuplicateIdentityAttrs && oldDevicesWithHostName.Count != 1)) {
						// The host name is not unique in the old network
						return;
					}
				}

				var newDevicesWithHostName:List<Device> = newDevices.FindByHostName(oldDevHostName);
				if ((newDevicesWithHostName == null) ||
					(!settings.UseDuplicateIdentityAttrs && newDevicesWithHostName.Count != 1)) {
					// The host name is not unique in the new network
					return;
				}

				// We found matches on host name
				newDevicesWithHostName.ForEach((newDevice) => {
					hostNameMatches.Add(newDevice);
				}, this);
			}
		}
	}

	private static FindSerialNumberMatches(oldDevSerNums: HashSet<SerialNumberInfo>,
		oldDevices: DeviceSet, newDevices: DeviceSet,
		settings: NetworkDiffSettings,
		serialNumberMatches: Dictionary<Device, Array<SerialNumberInfo>>) {

		oldDevSerNums.ForEach((serialNumber) => {
			if (oldDevices != null) {
				var oldDevicesWithSerNum: List<Device> = oldDevices.FindBySerialNumber(serialNumber);
				if ((oldDevicesWithSerNum == null) ||
					(!settings.UseDuplicateIdentityAttrs && oldDevicesWithSerNum.Count != 1)) {
					// The serial number is not unique in the old network
					return;
				}
			}

			var newDevicesWithSerNum: List<Device> = newDevices.FindBySerialNumber(serialNumber);
			if ((newDevicesWithSerNum == null) ||
				(!settings.UseDuplicateIdentityAttrs && newDevicesWithSerNum.Count != 1)) {
				// The serial number is not unique in the new network
				return;
			}

			//// We found a match on serial number
			//Device newDevice = newDevicesWithSerNum[0];
			//if (!serialNumberMatches.ContainsKey(newDevice))
			//{
			//    serialNumberMatches[newDevice] = new List<SerialNumberInfo>();
			//}
			//serialNumberMatches[newDevice].Add(serialNumber);

			// We found matches on serial number
            newDevicesWithSerNum.ForEach((newDevice, index, array) => {
                if (!serialNumberMatches.ContainsKey(newDevice)) {
                    serialNumberMatches.Add(newDevice, new Array<SerialNumberInfo>());
                }
                serialNumberMatches.Item(newDevice).push(serialNumber);
            }, this);
		}, this);
	}

    private static FindDependentDeviceIdMatches(oldDepDevId: DependentDeviceId,
        oldDevices: DeviceSet, newDevices: DeviceSet,
        settings: NetworkDiffSettings,
        depDevIdMatches: HashSet<Device>) : void {

        if (oldDepDevId != null) {
            if (oldDevices != null) {
                var oldDevicesWithDepDevId: List <Device> = oldDevices.FindDependentDevicesById(oldDepDevId);
                if ((oldDevicesWithDepDevId == null) ||
                    (!settings.UseDuplicateIdentityAttrs && oldDevicesWithDepDevId.Count != 1)) {
                    // The dependent device id is not unique in the old network
                    return;
                }
            }

            var newDevicesWithDepDevId: List<Device> = newDevices.FindDependentDevicesById(oldDepDevId);
            if ((newDevicesWithDepDevId == null) ||
                (!settings.UseDuplicateIdentityAttrs && newDevicesWithDepDevId.Count != 1)) {
                // The dependent device id is not unique in the new network
                return;
            }

            // We found matches on dependent device id
            newDevicesWithDepDevId.ForEach((newDevice) => {
                depDevIdMatches.Add(newDevice);
            }, this);
        }
    }


    // ...


}

